import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ToolsPage() {
  const tools = [
    {
      icon: 'ri-quill-pen-line',
      title: 'Caption Generator',
      description: 'Generate engaging AI-powered captions for your social media posts in seconds',
      link: '/tools/caption-generator',
      color: 'from-[#e4f4ff] to-[#b3d9ff]',
      popular: true,
    },
    {
      icon: 'ri-hashtag',
      title: 'Hashtag Generator',
      description: 'Discover trending and relevant hashtags to boost your post reach',
      link: '/tools/hashtag-generator',
      color: 'from-[#e4f4ff] to-[#b3d9ff]',
      popular: true,
    },
    {
      icon: 'ri-time-line',
      title: 'Best Time to Post',
      description: 'Find the optimal posting times for maximum engagement',
      link: '/tools/best-time-to-post',
      color: 'from-gray-100 to-gray-200',
      comingSoon: true,
    },
    {
      icon: 'ri-user-line',
      title: 'Bio Generator',
      description: 'Create compelling social media bios that attract followers',
      link: '/tools/bio-generator',
      color: 'from-gray-100 to-gray-200',
      comingSoon: true,
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Engagement Calculator',
      description: 'Calculate your engagement rate and compare with industry benchmarks',
      link: '/tools/engagement-calculator',
      color: 'from-gray-100 to-gray-200',
      comingSoon: true,
    },
    {
      icon: 'ri-calendar-line',
      title: 'Content Calendar',
      description: 'Download our free content calendar template with holiday suggestions',
      link: '/tools/content-calendar',
      color: 'from-gray-100 to-gray-200',
      comingSoon: true,
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#e4f4ff]/20 via-white to-[#b3d9ff]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
            <i className="ri-tools-line mr-2"></i>
            Free Marketing Tools
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#22577A] mb-6">
            Powerful Tools to
            <span className="block text-[#38a3a5]">Boost Your Content</span>
          </h1>

          <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto">
            Professional-grade social media tools, completely free. No credit card required.
          </p>
        </div>
      </section>

      {/* Tools Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {tools.map((tool, index) => (
              <a
                key={index}
                href={tool.comingSoon ? '#' : tool.link}
                className={`relative bg-gradient-to-br ${tool.color} rounded-2xl p-8 border-2 ${
                  tool.comingSoon
                    ? 'border-gray-200 cursor-default'
                    : 'border-[#66b3ff] hover:border-[#22577A] hover:shadow-2xl'
                } transition-all group ${tool.comingSoon ? 'opacity-60' : ''}`}
              >
                {tool.popular && (
                  <div className="absolute top-4 right-4">
                    <span className="inline-flex items-center px-3 py-1 bg-[#22577A] text-white text-xs font-semibold rounded-full">
                      <i className="ri-fire-line mr-1"></i>
                      Popular
                    </span>
                  </div>
                )}

                {tool.comingSoon && (
                  <div className="absolute top-4 right-4">
                    <span className="inline-flex items-center px-3 py-1 bg-gray-400 text-white text-xs font-semibold rounded-full">
                      Coming Soon
                    </span>
                  </div>
                )}

                <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${tool.icon} text-4xl text-[#22577A]`}></i>
                </div>

                <h3 className="text-2xl font-bold text-[#22577A] mb-3">{tool.title}</h3>
                <p className="text-gray-700 leading-relaxed mb-6">{tool.description}</p>

                {!tool.comingSoon && (
                  <div className="flex items-center gap-2 text-[#22577A] font-semibold group-hover:gap-3 transition-all">
                    Try it free
                    <i className="ri-arrow-right-line"></i>
                  </div>
                )}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Want More Powerful Features?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Get access to our complete suite of AI-powered marketing tools with MandaPost Pro.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/signup"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-lg font-semibold text-lg hover:shadow-xl hover:scale-105 transition-all cursor-pointer"
            >
              <i className="ri-play-circle-line"></i>
              Start Free Trial
            </a>
            <a
              href="/features"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white/10 hover:scale-105 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
              View All Features
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
